import React, { useState, useContext, useEffect, useRef } from 'react';
import { AppActions } from 'store';
import { StateContext, DispatchContext } from 'context';
import './inicio.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    // faChevronLeft, faChevronRight,
    faEnvelope, faMapMarkerAlt, faPhone
} from '@fortawesome/free-solid-svg-icons';
// import { faFacebookSquare, faInstagram, faTwitterSquare, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

//------------------------------------------------------------------------------------------------------
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import { useWindowSize } from 'hooks';
import {
    Slide1,
    // Slide2, Slide3,
    Western, Infonet, Aquipago,
    ServicioAnde, ServicioFamiliar, ServicioTigo, ServicioItau, ServicioPersonal, ServicioEssap, ServicioCopaco, ServicioClaro,
    DescuentoDeCheques1Img, VacacionesImg, PrestamosPersonales2Img
} from 'assets/img';

import { EqualHeight, EqualHeightElement } from 'react-equal-height';

import useSize from '@react-hook/size';
// import useScrollPosition from '@react-hook/window-scroll';
// import { WidgetClima } from 'app/widget-clima';
import { LogoCabanaNaRosaCue, LogoElCapon, LogoGrupoSerNegro, LogoServicom, LogoServiajeros, LogoServitravel, LogoTipo } from 'assets/logos';

import { useNavigate } from "react-router-dom";
import { faFacebookSquare, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const Inicio = props => {
    const dispatch = useContext(DispatchContext);
    const state = useContext(StateContext);
    // const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    // const windowSize = useWindowSize();
    // const scrollY = useScrollPosition(60);
    let navigate = useNavigate();
    const [slides, setSlides] = useState([
        {
            id: 1,
            img: PrestamosPersonales2Img,
            pagina: 'prestamos',
            titulo: "Préstamos personales",
            texto: '<span>SERFIN</span> te da la solución para conseguir el préstamo personal que estabas buscando.'
            // texto: '<span>S<span className="minuscula-inicio">ER</span>F<span className="minuscula-inicio">IN</span></span> te da la solución para conseguir el préstamo personal que estabas buscando.'
        },
        {
            id: 2,
            img: DescuentoDeCheques1Img,
            pagina: 'descuento-de-cheques',
            titulo: "Descuentos de cheques",
            texto: "Efectivizá tus cheques de forma rápida, segura, y confiable."
        },
        {
            id: 3,
            img: VacacionesImg,
            pagina: 'creditos-de-turismo',
            titulo: "Créditos de turismo",
            texto: 'Hacé ese viaje que tanto anhelas y las vacaciones que te mereces, y abónalo con la facilidad que <span>S<span className="minuscula">ER</span>F<span className="minuscula">IN</span></span> te ofrece.'
        },
        {
            id: 4,
            img: Slide1,
            pagina: 'prestamos',
            titulo: "Pymes y Mipymes",
            texto: 'Apoyamos a las micro, pequeñas y medianas empresas ofreciendo préstamos a la medida.'
        }
    ]);
    const [cobros, setCobros] = useState([
        {
            id: 1,
            img: Western,
            titulo: "Giros Western Union",
            texto: 'Somos Agente de la empresa internacional Western Union, líder mundial en remesas internacionales. Western Union cuenta con más de 400.000 centros de atención en todo el mundo, acercate a nuestras oficinas para enviar y recibir dinero a  más de 200 países.',
            texto2: 'Somos Agente de la empresa internacional Western Union'
        },
        {
            id: 2,
            img: Infonet,
            titulo: "Infonet Cobranzas",
            texto: "Este sitio le permite abonar facturas de servicios públicos y privados, con tarjetas de débito de manera segura y confiable. Es el primer Portal de Pagos dirigido a los usuarios de Tarjetas de Débito del país, permitiedo cómoda y sencillamente cumplir con las cuentas, como también realizar recargas de saldo de todas las operadoras las 24 horas y desde cualquier lugar.",
            texto2: 'Paga tus facturas de servicios en nuestros locales a través de Infonet Cobranzas'
        },
        {
            id: 3,
            img: Aquipago,
            titulo: "Aqui Pago",
            texto: "Este sitio le permite abonar facturas de servicios públicos y privados, con tarjetas de débito de manera segura y confiable. Es el primer Portal de Pagos dirigido a los usuarios de Tarjetas de Débito del país, permitiedo cómoda y sencillamente cumplir con las cuentas, como también realizar recargas de saldo de todas las operadoras las 24 horas y desde cualquier lugar.",
            texto2: 'Podés pagar las cuotas de tus préstamos SERFIN en todos los puntos de AQUI PAGO'
        }
    ]);
    const [servicios, setServicios] = useState([
        {
            id: 1,
            nombre: "Ande",
            img: ServicioAnde
        },
        {
            id: 2,
            nombre: "Essap",
            img: ServicioEssap
        },
        {
            id: 3,
            nombre: "Copaco",
            img: ServicioCopaco
        },
        {
            id: 4,
            nombre: "Tigo",
            img: ServicioTigo
        },
        {
            id: 5,
            nombre: "Personal",
            img: ServicioPersonal
        },
        {
            id: 6,
            nombre: "Claro",
            img: ServicioClaro
        },
        {
            id: 7,
            nombre: "Itaú",
            img: ServicioItau
        },
        {
            id: 8,
            nombre: "Banco Familiar",
            img: ServicioFamiliar
        }
    ]);
    const holding = [
        {
            id: 1,
            empresa: "Serfin S.A.",
            logo: LogoTipo,
            clase: 'logo-serfin',
            link: 'https://www.serfin.com.py'
        },
        {
            id: 2,
            empresa: "Servitravel",
            logo: LogoServitravel,
            clase: 'logo-servitravel',
            link: 'https://www.instagram.com/servitravel/'
        },
        {
            id: 3,
            empresa: "Servicom",
            logo: LogoServicom,
            clase: 'logo-servicom',
            link: 'https://www.serfin.com.py'
        },
        {
            id: 4,
            empresa: "SerViajeros",
            logo: LogoServiajeros,
            clase: 'logo-serviajeros',
            link: 'https://serviajeros.com.py/'
        },
        {
            id: 5,
            empresa: "El Capón",
            logo: LogoElCapon,
            clase: 'logo-el-capon',
            link: 'https://www.instagram.com/elcaponpy_cordero/'
        },
        {
            id: 6,
            empresa: "Cabaña Ña Rosa Cué",
            logo: LogoCabanaNaRosaCue,
            clase: 'logo-rosa-cue',
            link: 'https://www.instagram.com/narosacue/'
        }
    ]
    const target1 = useRef(null);
    const masAlto = useRef(null);
    const [widthBanner, heightBanner] = useSize(target1);
    const [widthCobros, heightCobros] = useSize(masAlto);
    useEffect(() => {
        dispatch(AppActions.setLoading(false));
        dispatch(AppActions.setActionsDisabled(false));
        document.title = 'Serfin S.A.';

    }, []);
    const navegar = (target) => {
        navigate(target);
        props.scrollTop();
    };
    return (
        <>
            <div id="inicio-container" className="bs-bbox" style={{ minHeight: heightBanner }}>
                <div className="bs-bbox" style={{ width: '100%', height: '100%', position: 'relative' }}>
                    {slides ? <CarouselProvider
                        naturalSlideWidth={100}
                        totalSlides={slides.length}
                        visibleSlides={1}
                        infinite={true}
                        interval={6000}
                        isPlaying={true}>
                        <div style={{ width: '100%', height: heightBanner, position: 'relative', margin: 'auto' }}>
                            <Slider style={{ height: '100%' }}>
                                {slides.map((slde, index) => <Slide key={'slide-' + slde.id} index={index} style={{ padding: 4 }}>
                                    <div className="w3-content inicio-content" ref={target1}>
                                        <div className="w3-row">
                                            <div className="w3-col l4 m4 col-img">
                                                <div className="img-container w3-card" style={{ backgroundImage: `url('${slde.img}')` }}>

                                                </div>
                                            </div>
                                            <div className="w3-col l8 m8 col-textos">
                                                <h1 className="w3-text-white xno-seleccionable">{slde.titulo}</h1>
                                                <p dangerouslySetInnerHTML={{ __html: slde.texto }} className="w3-text-white xno-seleccionable"></p>
                                                <button onClick={() => navegar(slde.pagina)} className="w3-btn w3-xlarge w3-round-xxlarge w3-yellow w3-text-theme">Ver más</button>
                                            </div>
                                        </div>
                                    </div>
                                </Slide>)}
                            </Slider>

                            <div className="dots-container w3-center">
                                <DotGroup />
                            </div>

                            {/* <div id="button-back-container">
                                <ButtonBack className="w3-btn boton-slide"><FontAwesomeIcon icon={faChevronLeft} color="#fff" /></ButtonBack>
                            </div>
                            <div id="button-next-container">
                                <ButtonNext className="w3-btn boton-slide"><FontAwesomeIcon icon={faChevronRight} color="#fff" /></ButtonNext>
                            </div> */}
                        </div>
                    </CarouselProvider> : null}
                </div>
                {/* <div className="w3-content w3-padding w3-center">
                    <a className="links-contacto w3-btn w3-round-xxlarge" href="tel:59521204365"><FontAwesomeIcon icon={faPhone} color="#fff" /> &nbsp;&nbsp;&nbsp;021 204 365</a>
                    <a className="links-contacto w3-btn w3-round-xxlarge" href="tel:595800118300"><FontAwesomeIcon icon={faPhone} color="#fff" /> &nbsp;&nbsp;&nbsp;0800 11 8300</a>
                    <a className="links-contacto w3-btn w3-round-xxlarge" href="mailto:info@serfin.com.py"><FontAwesomeIcon icon={faEnvelope} color="#fff" /> &nbsp;&nbsp;&nbsp;info@serfin.com.py</a>
                    <a className="links-contacto w3-btn w3-round-xxlarge" href="https://goo.gl/maps/7v8XSuV4c4EvKfQy7" target="_blank"><FontAwesomeIcon icon={faMapMarkerAlt} color="#fff" /> &nbsp;&nbsp;Casa central, Asunción Paraguay</a>
                </div> */}
                {/* <div className="w3-block w3-center contenedor-links-contacto">
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" href="https://goo.gl/maps/7v8XSuV4c4EvKfQy7" target="_blank"><FontAwesomeIcon icon={faMapMarkerAlt} color="#fff" /> &nbsp;&nbsp;Casa central, Asunción Paraguay</a>
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" href="tel:59521204365"><FontAwesomeIcon icon={faPhone} color="#fff" /> &nbsp;&nbsp;&nbsp;021 204 365</a>
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" href="mailto:info@serfin.com.py"><FontAwesomeIcon icon={faEnvelope} color="#fff" /> &nbsp;&nbsp;&nbsp;info@serfin.com.py</a>
                        </div> */}
            </div>
            <div className="contenedor-inferior-inicio">
                <div className="w3-block texto-desde">
                    <div className="w3-content w3-center">
                        <h2 className="xno-seleccionable">Desde 1995 ofrecemos servicios financieros, ágiles y oportunos a personas y pymes.</h2>
                        <div className="w3-block w3-center contenedor-links-contacto">
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" href="https://goo.gl/maps/7v8XSuV4c4EvKfQy7" target="_blank"><FontAwesomeIcon icon={faMapMarkerAlt} color="#fff" /> &nbsp;&nbsp;Casa central, Asunción Paraguay</a>
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" href="https://wa.me/595986904900"><FontAwesomeIcon icon={faWhatsapp} color="#fff" /> &nbsp;&nbsp;&nbsp;+595 986 904900</a>
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" href="tel:59521204365"><FontAwesomeIcon icon={faPhone} color="#fff" /> &nbsp;&nbsp;&nbsp;021 204 365</a>
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" href="mailto:info@serfin.com.py"><FontAwesomeIcon icon={faEnvelope} color="#fff" /> &nbsp;&nbsp;&nbsp;info@serfin.com.py</a>
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" target="_blank" href="https://www.facebook.com/Serfin-SA-208620082518478" aria-label="Facebook"><FontAwesomeIcon icon={faFacebookSquare} color="#fff" /></a>
                            <a className="links-contacto w3-btn w3-round-xxlarge w3-theme-d4" target="_blank" href="https://www.instagram.com/serfin_sa/" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} color="#fff" /></a>
                        </div>
                    </div>
                </div>
                {/* <div id="cotizaciones" className="w3-block ">
                    <div className="w3-content">
                        <div className="w3-row">
                            <div className="w3-col l4">
                                <iframe width="400" height="300" src="http://www.cambioschaco.com.py/widgets/cotizacion/?lang=es" frameBorder="0"></iframe>
                            </div>
                            <div className="w3-col l4" style={{ paddingTop: '30px' }}>
                                <WidgetClima />
                            </div>
                            <div className="w3-col l4 w3-center">
                                <iframe id="widgetMataf" src="https://www.mataf.net/es/widget/conversiontab-USD-PYG?list=PYG|USD|ARS|BRL|EUR|&amp;a=1" style={{ border: 'none', overflow: 'hidden', backgroundColor: 'transparent', height: '350px', width: '300px' }}></iframe>
                            </div>
                        </div>
                    </div>
                </div> */}
                <div id="holding">
                    <div className="w3-block w3-center titulo-container">
                        <span>Somos </span><img src={LogoGrupoSerNegro} alt="logo-grupo-ser" className="logo-grupo-ser" /><span id="titulo">:</span>
                    </div>
                    <div className="w3-content">
                        <EqualHeight>
                            <div className="w3-row fila">
                                {holding.map((empresa, index) => <a href={empresa.link} target="_blank" key={'empresa-' + empresa.id}>
                                    <div className="w3-col w3-center">
                                        <div>
                                            <EqualHeightElement name="Name">
                                                <img src={empresa.logo} className={empresa.clase} alt={'logo-' + empresa.empresa} />
                                            </EqualHeightElement>
                                        </div>
                                    </div>
                                </a>)}
                            </div>
                        </EqualHeight>
                    </div>
                </div>
                <div id="cobros" className="w3-block">
                    <div className="w3-content">
                        <EqualHeight>
                            <div className="w3-row fila">
                                {cobros.map((cob, index) => <div key={'cobro-' + cob.id} className="w3-col l4 w3-center">
                                    <div className="w3-card w3-white w3-round-xxlarge w3-light-gray">
                                        <EqualHeightElement name="Name">
                                            <img className="w3-block w3-round-xlarge" src={cob.img} alt={cob.titulo}/>
                                            {/* <h3>{cob.titulo}</h3> */}
                                            <p className="w3-text-theme-d2">{cob.texto2}</p>
                                        </EqualHeightElement>
                                    </div>
                                </div>)}
                                {/* <div className="w3-col l12 w3-center">
                                    <div className="w3-card aqui-pago w3-white w3-round-xxlarge w3-light-gray">
                                        <div className="w3-row">
                                            <div className="w3-col l6">
                                                <img className="w3-block w3-round-xlarge" src={Aquipago} />
                                            </div>
                                            <div className="w3-rest w3-padding">
                                                <p className="w3-text-theme-d2" style={{margin: '0px'}}>Podés pagar las cuotas de tus préstamos SERFIN en todos los puntos de AQUI PAGO</p>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </EqualHeight>
                        {/* <EqualHeight>
                            <div className="w3-row">
                                {cobros.map((cob, index) => <div key={cob.id} className="w3-col l4">
                                    <div className="w3-card w3-white">
                                        <EqualHeightElement name="Name">
                                            <img className="w3-block" src={cob.img} />
                                            <h3>{cob.titulo}</h3>
                                            <p>{cob.texto}</p>
                                        </EqualHeightElement>
                                    </div>
                                </div>)}
                            </div>
                        </EqualHeight> */}
                        {/* {servicios ? <CarouselProvider
                            totalSlides={servicios.length}
                            naturalSlideWidth={100}
                            visibleSlides={4}
                            infinite={true}
                            interval={3000}
                            isPlaying={true}>
                            <div style={{ width: '100%', maxWidth: '520px', height: '180px', position: 'relative', margin: 'auto' }}>
                                <Slider style={{ height: '100%' }}>
                                    {servicios.map((serv, index) => <Slide key={serv.id} index={index} style={{ padding: 4 }}>
                                        <div className="servicios-col">
                                            <img src={serv.img} className="w3-block" alt={serv.nombre} />
                                        </div>
                                    </Slide>)}
                                </Slider>
                            </div>
                        </CarouselProvider> : null} */}
                    </div>
                </div>
            </div>

        </>
    );
}
export default Inicio;